// PHP json_encode turns sparse lists into objects; named-key blobs stay single entries.
export function normalizePhpListish(v: unknown): unknown[] {
  if (v == null) return [];
  if (Array.isArray(v)) return v;
  if (typeof v !== 'object') return [v];
  const keys = Object.keys(v);
  if (keys.length === 0) return [];
  if (keys.every((k) => /^\d+$/.test(k))) return Object.values(v);
  return [v];
}
